<template>
  <div
    class="catalogue"
    v-bind:class="[
      useType == 1 ? 'outgoing' : '',
      useType == 2 ? 'incoming' : '',
    ]"
  >
    <h3 class="item-name">
      {{ item.name }}
    </h3>
    <img v-lazy="item.imagePath" />
    <a
      class="download-button"
      :id="productName + item.id"
      href="#"
      v-on:click="downloadPdf(item.downloadUri, productName, item.id)"
    >
      ダウンロード
    </a>
    <div class="download-file-description">
      ({{ item.pageCount }}ページ / {{ item.fileType }} : {{ item.fileSize }})
    </div>
  </div>
</template>

<script>
export default {
  props: ['useType', 'productName', 'item'],
  methods: {
    downloadPdf(uri, name, id) {
      var fileName = name + '-catalogue' + id + '.pdf'
      if (window.navigator.msSaveOrOpenBlob) {
        var xhr = new XMLHttpRequest()
        xhr.open('GET', uri)
        xhr.responseType = 'blob'
        xhr.onloadend = function() {
          if (xhr.status !== 200) {
            return false
          }
          window.navigator.msSaveOrOpenBlob(xhr.response, fileName)
        }
        xhr.send()
      } else {
        var link = document.getElementById(name + id)
        link.href = uri
        link.download = fileName
      }
    },
  },
}
</script>

<style scoped>
.catalogue {
  align-self: flex-start;

  width: 48%;
  margin-bottom: 40px;

  text-align: center;
}

.sp-catalogues .catalogue {
  width: 100%;
}

.catalogue .item-name {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;

  padding-left: 10px;

  text-align: left;
}

.catalogue img {
  display: block;

  width: auto;
  height: 280px;
  margin: 25px auto;

  border: 1px solid #ccc;
}

.catalogue.outgoing .item-name {
  color: rgb(20, 149, 23);
  border-left: 10px solid rgb(45, 183, 68);
  background-color: rgb(186, 233, 193);
}

.catalogue.incoming .item-name {
  color: rgb(11, 92, 154);
  border-left: 10px solid rgb(16, 106, 203);
  background-color: rgb(184, 221, 253);
}

.catalogue .download-button {
  font-size: 16px;
  font-weight: bold;
  line-height: 36px;

  display: inline-block;

  width: 230px;

  cursor: pointer;
  text-decoration: none;

  color: white;
}

.catalogue.outgoing .download-button {
  background-color: rgb(45, 183, 68);
}

.catalogue.incoming .download-button {
  background-color: rgb(16, 106, 203);
}

.catalogue .download-file-description {
  font-size: 12px;

  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/products/Catalogue.vue